import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InputControl, InputDescription, Label, Input, } from '@awaze/design-system.components.input';
/**
 * A form component to select the start date of a holiday
 * */
export const StartDateInput = ({ formHooks, isRequired = false, maxDate, minDate, }) => (_jsxs(InputControl, { children: [_jsx(Label, { htmlFor: "start", children: "Start date" }), _jsx(InputDescription, { children: "Get exact prices and availability" }), _jsx(Input, { name: "start", formHooks: formHooks, isRequired: isRequired, type: "date", placeholder: "Select", minDate: minDate, maxDate: maxDate, validation: isRequired
                ? {
                    required: 'Please choose a start date for your booking',
                }
                : {} })] }));
//# sourceMappingURL=start-date-input.js.map